import React, { Component} from 'react';
import { connect } from 'react-redux';
import { submitAddRecordModal, recordAddModalChange, recordsAddModalClose} from '../../actions/recordsActions';
import { Form, Icon, Input, Button, Row, Col, Modal, Drawer} from 'antd';
const FormItem = Form.Item;
const { TextArea } = Input;

class RecordAddFormModal extends Component {

    validation(updatedSubmission){
        updatedSubmission['validation']['serial_number'] = '';
        updatedSubmission['validation']['hid'] = '';

        if(updatedSubmission['serial_number'].length > 5 )
            updatedSubmission['validation']['serial_number'] = 'должно не более 5 цифр';


        if(updatedSubmission['hid'].length > 0 && !/^([0-9A-Z-]{2}[-]{1}){16,}$/.test(updatedSubmission['hid']+'-'))
            updatedSubmission['validation']['hid'] = 'не похоже на HID';

        return updatedSubmission;
    }

    updateSubmission(event){
        let updatedSubmission = Object.assign({}, this.props.record_add_modal);

        updatedSubmission[event.target.id] = event.target.value;
        updatedSubmission['user'] = document.getElementById('user').value;
        updatedSubmission['serial_number'] = updatedSubmission['serial_number'].replace(/\D/ig, '');
        this.props.recordAddModalChange(this.validation(updatedSubmission));
    }

    addFormHasErrors(){
        if(Object.keys(this.props.record_add_modal.validation).some(item=>this.props.record_add_modal.validation[item].length>0))
            return true;

        if(this.props.record_add_modal.serial_number === '')
            return true;

        if(this.props.record_add_modal.hid === '')
            return true;
    }

    submitSubmission(){
        this.props.submitAddRecordModal(this.props.record_add_modal); 
        this.props.recordsAddModalClose();
    }

    render(){
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            }
        }

        return (
            <Drawer title="Создание новой записи"
                visible={this.props.record_add_modal.visible}
                onCancel={this.props.recordsAddModalClose.bind(this)}
                onOk={this.submitSubmission.bind(this)}
                width='700px'
                placement="right"
                onClose={this.props.recordsAddModalClose.bind(this)}
            >
                <Form layout="vertical">
                    <FormItem 
                        validateStatus={this.props.record_add_modal.validation.hid.length ? "error" : "success"}
                        help={this.props.record_add_modal.validation.hid}
                        {...formItemLayout}
                    >
                        <Input style={{ width:'600px' }} prefix={<Icon type="edit" style={{ color: 'rgba(0,0,0,.25)' }} />} value={this.props.record_add_modal.hid} onChange={this.updateSubmission.bind(this)} id="hid" disabled={this.props.record_add_modal.hidden_data ? true : false} type="text" placeholder= "HID: XX-XX-XX-XX-XX-XX-XX-XX-XX-XX-XX-XX-XX-XX-XX-XX" />
                    </FormItem>
                    <FormItem
                        validateStatus={this.props.record_add_modal.validation.serial_number.length ? "error" : "success"}
                        help={this.props.record_add_modal.validation.serial_number}
                        {...formItemLayout}
                    >
                        <Input style={{ width:'200px' }} prefix={<Icon type="edit" style={{ color: 'rgba(0,0,0,.25)' }} />} value={this.props.record_add_modal.serial_number} onChange={this.updateSubmission.bind(this)} id="serial_number" disabled={this.props.record_add_modal.hidden_data ? true : false} type="text" placeholder="SERIAL NUMBER: 00000" />
                    </FormItem>
                    <FormItem {...formItemLayout} >
                        <TextArea rows="4" cols="50" style={{width:'700px', height:"100px"}} value={this.props.record_add_modal.comments} onChange={this.updateSubmission.bind(this)} id="comments" placeholder="КОММЕНТАРИЙ" />
                        <Input type="hidden" id='user' name="user" value={localStorage.getItem('id')} />
                    </FormItem>
                </Form>

                <div
                    style={{
                        position: 'absolute',
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e8e8e8',
                        padding: '10px 16px',
                        textAlign: 'right',
                        left: 0,
                        background: '#fff',
                        borderRadius: '0 0 4px 4px',
                    }}
                >
                    <Button 
                        onClick={this.submitSubmission.bind(this)} 
                        disabled={this.addFormHasErrors()}
                        placement="right"
                        type="primary"
                        icon="key"
                    >
                    сгенерировать новый ключ активации
                    </Button>
                </div>
            </Drawer>
        )
    }
}

const mapStateToProps = state => ({
    record_add_modal: state.records.record_add_modal,
})

const mapDispatchToProps = dispatch => ({
    submitAddRecordModal: payload => dispatch(submitAddRecordModal(payload)),
    recordAddModalChange: payload => dispatch(recordAddModalChange(payload)),
    recordsAddModalClose: payload => dispatch(recordsAddModalClose())
});

export default connect(mapStateToProps, mapDispatchToProps)(RecordAddFormModal);


// WEBPACK FOOTER //
// ./src/components/containers/RecordAddFormModal.js